import styles from "./sponsors.module.css";
import Sponsor from "../../components/sponsors/sponsors";

const Sponsors = () => {
    return (
        <div>
            <Sponsor></Sponsor>
        </div>
    );
}
 
export default Sponsors;